export default "__VITE_ASSET__iizy2XuO__"